/**
 * Wrapper Input for the Zappos UI Input to pass Lumon style overrides
 */

import { Input as DesignLibraryInput, type InputProps } from '@mweb/zappos-ui/Input';

// TODO(Rebrand): Drop the Kratos version here once implemented.
// There are too many child elements to style with Tailwind efficiently,
// and it makes sense to copy + paste the new one.
export const Input = ({ ...forwardProps }: InputProps) => (
  // `className` prop on this doesn’t target container element
  <div className="lumon:[&_.rounded-lg]:rounded-sm">
    <DesignLibraryInput {...forwardProps} />
  </div>
);
